module.exports = __webpack_public_path__ + "images/bug_yellow_size_6_782f603f4faf65b0abcc69dcfc990318.png";